<template>
  <div>
    <v-runtime-template :template="includeTemplate"/>
    <wep-loading :is-loading="isLoading"/>
  </div>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'
import WepLoading from '~pages/contents/loading/WepLoading.vue'

export default {
  name: 'MemberSsonInfo',
  metaInfo () {
  },
  components: {
    VRuntimeTemplate, 'wep-loading': WepLoading
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      ptptConfmMsg: '',
      wepSets: this.getStore('mmpAuth').state.wepSets,
      isLoading: false
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
    // 'mbrFnm': {
    //   handler: function (newVal, oldVal) {
    //     if (isEmpty(this.newVal) && this.loginErr) {
    //       this.loginErr = false
    //     }
    //   }
    // }
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.mainTemplate)) {
      this.getEmptyTemplate('wepPtptConfm.html')
    } else {
      this.includeHtml = wepHtmlToString.mainTemplate
    }
    this.fnSsoLogin()
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    },
    openNotice () {
      document.querySelectorAll('.notice-item')[0].classList.toggle('opened')
    },
    async fnSsoLogin () {
      this.ptptConfmMsg = this.$t('WEP00040')
      let params = {
        token: this.$route.query.token,
        wepId: this.getStore('mmpAuth').state.saveId,
        ifLinkYn: 'N'
      }

      let resultInfo = await this.$http.mmp.memberSsoInfo(this, params)

      if (resultInfo.data.status !== 'OK') {
        this.ptptConfmMsg = this.$t('WEP00033')
      } else {
        this.isLoading = true
        if (resultInfo.data.data.wepAplConfmCd === 'S') {
          let session = Object.assign({}, {
            loginTime: new Date().getTime(),
            timeout: window.vue.config.session.timeout,
            authenticated: true,
            wepId: resultInfo.data.data.wepId,
            userId: resultInfo.data.data.wepApcId,
            mbrFnm: resultInfo.data.data.mbrFnm,
            emailAddr: resultInfo.data.data.emailAddr,
            wepApcTyp: resultInfo.data.data.wepApcTyp,
            excsTitlNm: resultInfo.data.data.excsTitlNm,
            cmntRpatInqrTm: resultInfo.data.data.cmntRpatInqrTm,
            cmntInqrCnt: resultInfo.data.data.cmntInqrCnt
          })

          this.getStore('root').commit('LOG_IN', session)
          let token = Object.assign({}, {
            tokenAuth: resultInfo.data.data.mbrToken
          })
          this.getStore('token').commit('REGISTER', token)
          this.getStore('mmpAuth').commit('SET_AUTO_LOGIN', {session: session, token: token})
          this.isLoading = false

          if (this.wepSets.videoTrnsTyp === '02' ) {
            this.getTemplate('wepAgenda.html', '0', 'classnow')
          } else if (this.wepSets.videoTrnsTyp === '03' ) {
            this.getTemplate('wepAgenda.html', '0', 'classnow')
          } else {
            this.getTemplate('wepEnter.html', '0', 'enter')
          }
        } else if (resultInfo.data.data.wepAplConfmCd === 'A') {
          this.ptptConfmMsg = this.$t('WEP00024')
          this.isLoading = false
        } else if (resultInfo.data.data.wepAplConfmCd === 'C') {
          this.ptptConfmMsg = this.$t('WEP00025')
          this.isLoading = false
        } else if (resultInfo.data.data.rtCd === '99') {
          this.ptptConfmMsg = this.$t('WEP00034')
          this.isLoading = false
        } else if (resultInfo.data.data.rtCd === '98') {
          this.ptptConfmMsg = this.$t('WEP00041')
          this.isLoading = false
        } else {
          this.ptptConfmMsg = this.$t('WEP00033')
          this.isLoading = false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/MemberSsoInfo.vue